document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('[id^="sc-slider-"]').forEach(function (container) {
    const swiperEl = container.querySelector('.sc-routine-swiper');
    const controllers = container.querySelectorAll('.controll-menu.boxery');
    const contentGroups = container.querySelectorAll('.additional-group');

    if (!swiperEl || typeof Swiper === 'undefined') return;

    const swiper = new Swiper(swiperEl, {
      slidesPerView: 1,
      spaceBetween: 0,
      autoHeight: true,
      loop: false,
      grabCursor: true,
      effect: 'slide',
      speed: 400,
      on: {
        slideChange: function () {
          syncUI(this.activeIndex);
        }
      }
    });

    function syncUI(index) {
      controllers.forEach(function (btn, i) {
        btn.classList.toggle('active', i === index);
      });
      contentGroups.forEach(function (group, i) {
        group.classList.toggle('active', i === index);
      });
    }

    controllers.forEach(function (btn, i) {
      btn.addEventListener('click', function () {
        swiper.slideTo(i);
        syncUI(i);
      });
    });
  });
});

if (typeof Swiper === 'undefined') {
  var swiperScript = document.createElement('script');
  swiperScript.src = 'https://cdn.jsdelivr.net/npm/swiper@11/swiper-bundle.min.js';
  swiperScript.onload = function () {
    document.dispatchEvent(new Event('DOMContentLoaded'));
  };
  document.head.appendChild(swiperScript);

  var swiperCSS = document.createElement('link');
  swiperCSS.rel = 'stylesheet';
  swiperCSS.href = 'https://cdn.jsdelivr.net/npm/swiper@11/swiper-bundle.min.css';
  document.head.appendChild(swiperCSS);
}
